import * as Headless from '@headlessui/react'
import clsx from 'clsx'
import React, { forwardRef } from 'react'

export function InputGroup({ children, className }) {
  return (
    <span className={clsx('relative block w-full [&>svg]:pointer-events-none [&>svg]:absolute [&>svg]:top-1/2 [&>svg]:h-4 [&>svg]:w-4 [&>svg]:-translate-y-1/2 [&>svg]:text-zinc-400', className)}>
      {children}
    </span>
  )
}

export const Input = forwardRef(function Input({ className, ...props }, ref) {
  return (
    <Headless.Input
      ref={ref}
      {...props}
      className={clsx(
        'block w-full rounded-lg border border-zinc-300 bg-white px-3 py-2 text-sm/6 text-zinc-950 shadow-sm transition placeholder:text-zinc-400',
        'hover:border-zinc-400 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20',
        'disabled:cursor-not-allowed disabled:bg-zinc-50 disabled:text-zinc-500 disabled:shadow-none',
        className
      )}
    />
  )
})
